import React, { useCallback, useState } from 'react';
import { Grid, IconButton, Tooltip } from '@mui/material';
import FlexContainer from '../../../components/styled/FlexContainer.styled';
import { transientOptions } from '../../../themes';
import { toast } from 'react-toastify';
import { CopyAll } from '@mui/icons-material';
import AnimateButton from '../../../components/@extended/AnimateButton';
import Button from '../../../components/Button';
import DeleteDialog from '../../../components/dialog/DeleteDialog';
import { styled } from '@mui/system';

const ThinText = styled('span')`
  font-weight: 300;
  font-family: monospace;
  font-size: 0.8rem;
  display: inline-block;
  text-align: ${({ __align }) => __align ?? 'center'};
`;
const SpacedThinText = styled(ThinText, transientOptions)`
  margin: ${({ __margin }) => __margin ?? '0'};
`;

const Api = ({
  data,
  handleGenerateApiKey,
  handleDeleteApiKey,
  submittingChaveApi
}) => {
  const [openRemoveKey, setRemoveKey] = useState(false);
  const [openConfirmation, setConfirmation] = useState(false);

  const handleCopyApiKey = useCallback(async (text) => {
    await window.navigator.clipboard.writeText(text);
    toast.info('Chave API copiada com sucesso');
  }, []);

  return (
    <Grid container spacing={2}>
      {data.secretKey && (
        <Grid item xs={12}>
          <FlexContainer
            __justifyContent={'flex-start'}
            __alignItems={'flex-start'}
            __direction={'column'}
          >
            <SpacedThinText __margin={'1rem 0 0 0'} __align={'left'}>
              Chave da API: <b>{data.secretId}</b>{' '}
              <Tooltip title={'Copiar'} arrow>
                <IconButton onClick={() => handleCopyApiKey(data.secretId)}>
                  <CopyAll />
                </IconButton>
              </Tooltip>
            </SpacedThinText>
            <SpacedThinText __margin={'0'} __align={'left'}>
              Segredo da API: <b>{data.secretKey}</b>{' '}
              <Tooltip title={'Copiar'} arrow>
                <IconButton onClick={() => handleCopyApiKey(data.secretKey)}>
                  <CopyAll />
                </IconButton>
              </Tooltip>
            </SpacedThinText>
          </FlexContainer>
          <Grid item xs={12}>
            <Grid container spacing={2} justifyContent="center" mt={1}>
              <Grid item>
                <AnimateButton>
                  <Button
                    disabled={submittingChaveApi}
                    disableElevation
                    fullWidth
                    size="large"
                    type="button"
                    variant="outlined"
                    color="secondary"
                    onClick={() => setRemoveKey(true)}
                  >
                    CANCELAR CHAVE
                  </Button>
                </AnimateButton>
              </Grid>
              <Grid item>
                <AnimateButton>
                  <Button
                    disabled={submittingChaveApi}
                    disableElevation
                    fullWidth
                    size="large"
                    variant="contained"
                    color="primary"
                    onClick={() => setConfirmation(true)}
                  >
                    GERAR NOVA CHAVE
                  </Button>
                </AnimateButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
      {!data.secretKey && (
        <Grid item xs={12}>
          <FlexContainer
            __direction={'column'}
            __justifyContent={'center'}
            __alignItems={'center'}
          >
            <SpacedThinText __margin={'1rem 0'}>
              Este cliente <b>não</b> possui chave de comunicação ativa.
            </SpacedThinText>
            <AnimateButton>
              <Button
                disabled={submittingChaveApi}
                disableElevation
                fullWidth
                size="large"
                variant="contained"
                color="primary"
                onClick={handleGenerateApiKey}
              >
                GERAR CHAVE
              </Button>
            </AnimateButton>
          </FlexContainer>
        </Grid>
      )}
      <DeleteDialog
        isConfirmacao={true}
        title={
          'Esta ação irá gerar uma nova chave e desabilitará a chave atual.\nDeseja continuar?'
        }
        open={openConfirmation}
        setOpen={setConfirmation}
        deleteFunction={handleGenerateApiKey}
      />
      <DeleteDialog
        title={'Remover chave de comunicação?'}
        open={openRemoveKey}
        setOpen={setRemoveKey}
        deleteFunction={handleDeleteApiKey}
      />
    </Grid>
  );
};

export default Api;
